import axios from "../general/HttpClient";

export function SendEmail(to, subject, text) {
    return axios.post("/api/email/sendEmail", { to, subject, text });
}
